import React, { useEffect } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { commonActions } from '../../../stores/_actions';

export const Transcation = (props) => {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const { styles, benefData, qPayMsg } = props;
  let trnsactionInfoList = [];
  let currency;
  let netAmt;
  let transferRate;
  let transferCharges;
  let lastPage;
  let beneficiaryList;
  let toCurrency;
  let custDetails;
  const dispatch = useDispatch();
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };

  useEffect(() => {
    dispatch(commonActions.getCustDetailsByCode(payload));
  }, []);

  useSelector((state) => {
    trnsactionInfoList = state.transcation?.data;
    currency = state.receivedCurr?.data;
    toCurrency = state.saveRemit?.toCurrency;
    transferRate = state.getTransferRate?.transferRate;
    transferCharges = state.getTransferRate?.transferCharges;
    lastPage = state.lastPage?.lastPage;
    beneficiaryList = state.beneficary?.data;
    custDetails = state.getCustDetails?.data;
  }, []);

  // let data;
  // if (trnsactionInfoList && props.transcationListData){
  //   data = trnsactionInfoList.filter((ele) => ele.Refno === props.transcationListData.ReferenceNo)[0];
  // }

  const paymentMode =
    props.transcationListData?.PaymentModeFlag == 'C'
      ? 'Cash On Counter'
      : props.transcationListData?.PaymentModeFlag == 'A'
        ? 'Bank Transfer'
        : 'K NET';

  const refNo = props.transcationListData?.ReferenceNo;
  // if (!netAmt) {
    netAmt = props.transcationListData?.NetAmount;
  // }
  const data = trnsactionInfoList?.filter((ele) => ele.Refno === refNo);

  let date = data && data[0]?.Trandate.split(' ')[0];

  const benefL = [];
  if (beneficiaryList) {
    for (let i = 0; i < beneficiaryList?.length; i++) {
      beneficiaryList[i].BenfName = beneficiaryList[i].BenfName.replace(/\s+/g, ' ');
      benefL.push(beneficiaryList[i]);
    }
  }
  let benef = benefL?.filter((ele) => ele.AccountNo == data?.[0]?.AccountNo);

  let accNo;
  let bankName;
  let branchName;
  let ifsc;
  if (benefData && benefData?.Service === 'BANK TRANSFER') {
    accNo = benefData?.AccountNo;
    bankName = benefData?.BenfBank;
    branchName = benefData?.BenfBranch;
    ifsc = benefData?.BicCode;
  } else if (benef.length > 0 && benef[0]?.Service === 'BANK TRANSFER') {
    accNo = benef[0]?.AccountNo;
    bankName = benef[0]?.BenfBank;
    branchName = benef[0]?.BenfBranch;
    ifsc = benef[0]?.BicCode;
  }

  let netCurr = data && data[0] ? data[0]?.CurrencyCode : currency;
  if (!netCurr) {
    netCurr = benefData?.CurrencyCode || benef[0]?.CurrencyCode;
  }
  
  if(!data || data.length === 0) {
    benef = benefL?.filter((ele) => ele.ServNO == props.transcationListData?.ServiceNumber);
    accNo = benef[0]?.AccountNo;
    bankName = benef[0]?.BenfBank;
    branchName = benef[0]?.BenfBranch;
    ifsc = benef[0]?.BicCode;
    netCurr = benef[0]?.CurrencyCode;
    date = props.transcationListData?.CreateDate?.split(' ')[0];
  }

  return (
    <div className={styles.transferSummary}>
      <p>
        Reference Number <span>{props.transcationListData?.ReferenceNo}</span>
      </p>
      {benef[0]?.Service === 'CASH PICK UP' && (
        <p>
          Pin <span>{props.transcationListData?.ReferenceNo}</span>
        </p>
      )}
      {/* <p>
        Token Number <span>{props.transcationListData?.ServiceNumber}</span>
      </p> */}
      <p>
        Customer Name <span>{profile?.CustomerName}</span>
      </p>
      <p>
        Contact No. <span>+{profile?.MobileNumber}</span>
      </p>
      <p>
        Email ID <span>{custDetails?.Email}</span>
      </p>
      <p>
        Address{' '}
        <span>
          {custDetails?.Addr1}
          {custDetails?.Addr2 && `, ${custDetails?.Addr2}`}
        </span>
      </p>
      <p>
        Beneficiary
        <span>
          {props.transcationListData?.BenFullName}
          {accNo && <span style={{ fontWeight: '13px', fontWeight: 'bold', fontFamily: 'montserratregular' }}>Account Number: {accNo}</span>}
          {bankName && <span style={{ fontWeight: '13px', fontWeight: 'bold', fontFamily: 'montserratregular' }}>{bankName}</span>}
          {branchName && <span style={{ fontWeight: '13px', fontWeight: 'bold', fontFamily: 'montserratregular' }}>{branchName}</span>}
          {ifsc && <span style={{ fontWeight: '13px', fontWeight: 'bold', fontFamily: 'montserratregular' }}>{ifsc}</span>}
        </span>
        {/* <span>Account Number: {props.transcationListData.CustomerCode}</span> */}
        {/* <span>{props.transcationListData.BenFullName}</span> */}
      </p>
      <p>
        Payment Mode <span>{props.transcationListData && paymentMode}</span>
      </p>
      {(data && data[0] && lastPage === 'My Transfers') ||
        (qPayMsg && (
          <p>
            Status <span style={{ color: 'red' }}>{(data && data[0]?.Status) || qPayMsg}</span>
          </p>
        ))}
      {date && lastPage === 'My Transfers' && (
        <p>
          Date <span>{date}</span>
        </p>
      )}
      <p>
        Receiver Amount{' '}
        <span>
          {netCurr} {props.transcationListData.FCYAmount}
        </span>
      </p>
      {/* <p>
        Transfer Rate <span className={styles.normal}>{props.transcationListData.MRate}</span>
      </p> */}
      <p>
        Transfer Rate <span>{props.transcationListData.MRate}</span>
      </p>
      <p>
        Transferred Amount <span className={styles.amouttransfer}>{parseFloat(props.transcationListData?.LCYAmount)?.toFixed(3)} KWD</span>
      </p>
      <p>
        {/* Transfer Fee <span>{data?.[0]?.Charges ? parseInt(Number(data?.[0]?.Charges)) : parseInt(Number(transferCharges))} KWD</span> */}
        Transfer Fee <span>{props.transcationListData.Charge} KWD</span>
      </p>
      <p>
        Total Amount <span className={styles.amouttransfer}>{netAmt} KWD</span>
      </p>
    </div>
  );
};
